var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaIconSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.460938,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E7E6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9761 11.616H25.2985L20.2246 17.4156L26.194 25.306H21.5202L17.86 20.5199L13.6709 25.306H11.3472L16.7745 19.1025L11.0481 11.6166H15.8405L19.1493 15.9912L22.9761 11.616ZM22.1614 23.9163H23.4482L15.1413 12.933H13.7605L22.1614 23.9163Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIconSquare);
export default __webpack_public_path__ + "static/media/Social Media Icon Square.80b13c89e1e7008280c744a265e4396e.svg";
export { ForwardRef as ReactComponent };